import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { User, UserFunctions, UserService } from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class AuthorizationService {
    private apiUserInfo$?: Observable<User>;
    private apiUserFunctions$?: Observable<UserFunctions>;

    constructor(private readonly userService: UserService) {}

    public getUserInfo(): Observable<User> {
        return this.apiUserInfo$ ? this.apiUserInfo$ : this.initApiUserInfoStream();
    }

    public getUserFunctions(): Observable<UserFunctions> {
        return this.apiUserFunctions$ ? this.apiUserFunctions$ : this.initApiUserFunctionsStream();
    }

    private initApiUserInfoStream(): Observable<User> {
        this.apiUserInfo$ = this.userService.initUser().pipe(share());

        return this.apiUserInfo$;
    }

    private initApiUserFunctionsStream(): Observable<UserFunctions> {
        return this.userService.getUserFunctions().pipe(share());
    }

    public onLogout(): void {
        this.apiUserInfo$ = undefined;
        this.apiUserFunctions$ = undefined;
    }
}
